import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../assets/css/creerCompte.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Modal from "react-modal"; // Importez le composant Modal

// Définissez les styles par défaut pour la modal (facultatif, mais recommandé)
const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#f8f9fa",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        textAlign: "center",
    },
    overlay: {
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        zIndex: 1000, // Assurez-vous que la modal est au-dessus des autres éléments
    },
};

// Liez l'application pour l'accessibilité (obligatoire)
Modal.setAppElement("#root"); // Remplacez '#root' par l'ID de votre élément racine

export default function Creer_compte() {
    const { t } = useTranslation("creer_compte");
    const [nom, setNom] = useState("");
    const [email, setEmail] = useState("");
    const [modalIsOpen, setModalIsOpen] = useState(false); // État pour contrôler l'affichage de la modal
    const [modalMessage, setModalMessage] = useState(""); // Message à afficher dans la modal
    const [modalIsError, setModalIsError] = useState(false); // Indique si le message est une erreur
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();
    const API_BASE_URL = process.env.REACT_APP_API_URL;
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const openModal = (message, isError = false) => {
        setModalMessage(message);
        setModalIsError(isError);
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        if (
            !modalIsError &&
            modalMessage === t("subscriptionSuccessWithName")
        ) {
            navigate("/"); // Rediriger après le succès
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsSubmitting(true);

        try {
            const response = await axios.post(
                `${API_BASE_URL}/api/newsletter/subscribe`,
                { email, nom }
            );
            if (response.status === 201) {
                openModal(t("subscriptionSuccessWithName"));
            } else if (response.status === 409) {
                // <--- Cette condition doit être gérée
                openModal(t("alreadySubscribed"), true);
            } else {
                openModal(t("subscriptionFailed"), true);
            }
        } catch (error) {
            console.error(
                "Erreur lors de l'inscription à la newsletter:",
                error
            );
            if (error.response && error.response.status === 409) {
                // <--- Vérifiez ici aussi dans le catch
                openModal(t("alreadySubscribed"), true);
            } else if (error.message === "Network Error") {
                openModal(t("networkError"), true);
            } else if (error.response) {
                openModal(t("subscriptionFailed"), true);
            } else {
                openModal(t("subscriptionFailed"), true);
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="creer-compte-page">
            <div className="creer-compte-container">
                <h2 className="creer-compte-title">{t("titleNewsletter")}</h2>
                <form onSubmit={handleSubmit} className="creer-compte-form">
                    <div className="form-group">
                        <p>{t("nomLabel")}</p>
                        <input
                            type="text"
                            id="nom"
                            className="form-control"
                            value={nom}
                            onChange={(e) => setNom(e.target.value)}
                            style={{ color: "white" }}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <p>{t("emailLabel")}</p>
                        <input
                            type="email"
                            id="email"
                            className="form-control"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            style={{ color: "white" }}
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        className="creer-compte-button"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? t("subscribing") : t("subscribeButton")}
                    </button>
                </form>

                {/* Composant Modal */}
                <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={closeModal}
                    style={customStyles}
                    contentLabel="Subscription Status"
                >
                    <h2>
                        {modalIsError
                            ? t("subscriptionErrorTitle")
                            : t("subscriptionSuccessTitle")}
                    </h2>
                    <p>{modalMessage}</p>
                    <button
                        onClick={closeModal}
                        className="creer-compte-button"
                    >
                        {t("close")}
                    </button>
                </Modal>
            </div>
        </div>
    );
}
